export enum UserRole {
	None = 'Not Logged In',
	User = 'User',
	CSA = 'CSA',
	RacoAdmin = 'RACO Admin',
	SuperCSA = 'Super CSA',
}
